import { InjectionToken } from '@angular/core';
import type { ThemePreference } from './theme.service';

// 'write' — only explicit choices go into the cookie; 'read-write' — the cookie is also read first.
export type ThemeSharedCookie = false | 'write' | 'read-write';

export interface ThemeOptions {
  readonly defaultPreference: ThemePreference;
  readonly storageKey: string;
  readonly sharedCookie: ThemeSharedCookie;
}

export const THEME_OPTIONS = new InjectionToken<ThemeOptions>('THEME_OPTIONS', {
  providedIn: 'root',
  factory: () => ({ defaultPreference: 'dark', storageKey: 'pcl-theme', sharedCookie: false }),
});
